/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import { prices } from "@/common/constants"

/**
 * Get pricing items by ids
 * @param ids pricing item ids
 */
export function getPricingItems(ids) {
  return ids.map(id => {
    const pricingItem = prices.find(price => price.id === id)
    return {
      name: pricingItem.name,
      description: `$${pricingItem.price.toFixed(2)}/${pricingItem.unit}`
    }
  })
}



// WEBPACK FOOTER //
// ./src/service/lineitem.js